export default __webpack_public_path__ + "static/media/xpensityv2-lg-3.ff24a785.webp";